var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper", attrs: { id: "top" } }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showOverlay,
                      expression: "showOverlay"
                    }
                  ],
                  staticClass: "modal-custom"
                },
                [_vm._m(0)]
              ),
              _vm._v(" "),
              _c("div", [
                _c("div", {}, [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Notification Manager")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-blue float-right create-btn ml-1",
                      on: {
                        click: function($event) {
                          _vm.fetchCategoryLists(),
                            (_vm.isCategoryModalVisible = true),
                            (_vm.categoryLoading = true),
                            _vm.verrors.clear(),
                            (_vm.category_name = "")
                        }
                      }
                    },
                    [_vm._v("\n              Categories\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-blue float-right create-btn",
                      on: {
                        click: function($event) {
                          return _vm.createNotificationButton()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("Notification\n            ")
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c(
                "div",
                {},
                [
                  _c(
                    "b-navbar",
                    {
                      attrs: {
                        toggleable: "lg",
                        type: "light",
                        variant: "light"
                      }
                    },
                    [
                      _c("b-navbar-brand", { attrs: { href: "#" } }, [
                        _vm._v("Filter/Search")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-navbar-toggle",
                        { attrs: { target: "nav-collapse" } },
                        [_c("i", { staticClass: "fa fa-chevron-down\t" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "nav-collapse", "is-nav": "" } },
                        [
                          _c("div", { staticClass: "search-wrapper col-12" }, [
                            _c(
                              "div",
                              { staticClass: "row col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-lg-4 col-12" },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "input-text",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Search Template Name",
                                        maxlength: "255"
                                      },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.filterNotificationManageritems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_keyword,
                                        callback: function($$v) {
                                          _vm.search_keyword = $$v
                                        },
                                        expression: "search_keyword"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-lg-4 col-12" },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "input-text",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Search Subject Line",
                                        maxlength: "255"
                                      },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.filterNotificationManageritems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_subject,
                                        callback: function($$v) {
                                          _vm.search_subject = $$v
                                        },
                                        expression: "search_subject"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-lg-3 col-12 " },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "input-text",
                                      attrs: { options: _vm.category_options },
                                      on: {
                                        change: function($event) {
                                          return _vm.filterNotificationManageritems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_category,
                                        callback: function($$v) {
                                          _vm.search_category = $$v
                                        },
                                        expression: "search_category"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-1 col-12 search-icon-wrapper cursor-pointer"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "search-icon",
                                        attrs: { "data-v-6167ac87": "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.filterNotificationManageritems()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-search",
                                          attrs: { "data-v-6167ac87": "" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _vm.rows > 25
                ? _c(
                    "div",
                    {
                      staticClass:
                        "overflow-auto float-right pagination-wrapper",
                      staticStyle: { margin: "0" }
                    },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          "first-text": "First",
                          "prev-text": "Prev",
                          "next-text": "Next",
                          "last-text": "Last",
                          "hide-goto-end-buttons": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.showTasklistofPaginated()
                          }
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "row tasks_heading_row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer",
                      staticStyle: { width: "28%", "padding-left": "15px" },
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("templateName")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Template Name\n                "
                      ),
                      _vm.sortField == "templateName" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "templateName" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer",
                      staticStyle: { width: "28%" },
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("emailSubject")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Subject Line\n                "
                      ),
                      _vm.sortField == "emailSubject" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "emailSubject" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer",
                      staticStyle: { width: "12%" },
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("smsFlag")
                        }
                      }
                    },
                    [
                      _vm._v("\n                SMS Enabled\n                "),
                      _vm.sortField == "smsFlag" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "smsFlag" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer",
                      staticStyle: { width: "12%" },
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("pushFlag")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Push Enabled\n                "
                      ),
                      _vm.sortField == "pushFlag" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "pushFlag" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer",
                      staticStyle: { width: "14%" },
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("categoryName")
                        }
                      }
                    },
                    [
                      _vm._v("\n                Category\n                "),
                      _vm.sortField == "categoryName" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "categoryName" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold override-padding text-align-right",
                      staticStyle: { "padding-right": "20px", width: "6%" }
                    },
                    [_vm._v("\n                 \n              ")]
                  )
                ]),
                _vm._v(" "),
                _vm.notification_lists.length == 0 && _vm.loading == false
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 text-align-center",
                        staticStyle: {
                          "background-color": "#FFF",
                          "min-height": "480px",
                          "padding-top": "180px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 text-align-center no-assessment-text"
                          },
                          [_vm._v("No template matches your search.")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "loading_show"
                  },
                  [_c("div", { staticClass: "spinner-border text-danger" })]
                ),
                _vm._v(" "),
                _vm.notification_lists.length > 0
                  ? _c(
                      "div",
                      { staticClass: "card-text" },
                      [
                        _vm._l(_vm.notification_lists, function(list, index) {
                          return _c("div", { staticClass: "tasklists-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "row tasklist-item",
                                staticStyle: { margin: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "28%",
                                      "padding-left": "15px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(list.templateName) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { width: "28%" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(list.emailSubject) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "12%",
                                      "text-align": "left",
                                      "padding-left": "40px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.getSMSPushEmableValue(
                                            list.smsFlag
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "12%",
                                      "text-align": "left",
                                      "padding-left": "40px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.getSMSPushEmableValue(
                                            list.pushFlag
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { width: "14%" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(list.categoryName) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "override-padding",
                                    staticStyle: { width: "6%" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown",
                                        attrs: {
                                          id: "dropdown-container" + index
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleDropdown(
                                              "actionDropdown" + index + ""
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "dropbtn icons btn-right showLeft",
                                            staticStyle: { right: "30px" },
                                            attrs: { id: "dotted-menu" + index }
                                          },
                                          [
                                            _c("li"),
                                            _vm._v(" "),
                                            _c("li"),
                                            _vm._v(" "),
                                            _c("li")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-content",
                                            attrs: {
                                              id: "actionDropdown" + index
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "action-dd-menu",
                                                attrs: { href: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editNotificationMethod(
                                                      list.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "cursor-pointer fa fa-edit spacer-icon"
                                                }),
                                                _vm._v("Edit")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "action-dd-menu",
                                                attrs: { href: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteNotificationConfirm(
                                                      list.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "cursor-pointer fa fa-times spacer-icon"
                                                }),
                                                _vm._v("Delete")
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(1, true)
                          ])
                        }),
                        _vm._v(" "),
                        _vm.rows > 25
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "overflow-auto float-right pagination-wrapper",
                                staticStyle: { "margin-bottom": "0" }
                              },
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.rows,
                                    "per-page": _vm.perPage,
                                    "first-text": "First",
                                    "prev-text": "Prev",
                                    "next-text": "Next",
                                    "last-text": "Last",
                                    "hide-goto-end-buttons": true
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.showTasklistofPaginated()
                                    }
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CreateCategoryModal",
        {
          attrs: { isModalVisible: _vm.isCategoryModalVisible },
          on: {
            close: function($event) {
              _vm.isCategoryModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Notification Categories")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("div", { staticClass: "col-9 override-padding float-left" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.category_name,
                      expression: "category_name"
                    }
                  ],
                  staticClass: "col-lg-12 input-text form-control",
                  staticStyle: { "line-height": "30px" },
                  attrs: {
                    name: "category_name",
                    placeholder: "Enter Notification Category Name...",
                    maxlength: "140"
                  },
                  domProps: { value: _vm.category_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.category_name = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 override-padding float-left" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-blue col-12",
                    staticStyle: {
                      "line-height": "30px",
                      "margin-left": "15px"
                    },
                    on: {
                      click: function($event) {
                        return _vm.createCategory()
                      }
                    }
                  },
                  [_c("b", [_vm._v("Create")])]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.categoryLoading,
                    expression: "categoryLoading"
                  }
                ],
                staticClass: "loading_show"
              },
              [_c("div", { staticClass: "spinner-border text-danger" })]
            ),
            _vm._v(" "),
            _vm.categoryLoading == false
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding" },
                  [
                    _c("div", { staticStyle: { margin: "bottom: 10px" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "bold float-left",
                          staticStyle: { width: "50%", color: "#9B9B9B" }
                        },
                        [_vm._v("Category Name")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bold float-left",
                          staticStyle: { width: "30%", color: "#9B9B9B" }
                        },
                        [_vm._v("# of Notifications")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bold float-left",
                          staticStyle: { width: "20%" }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } })
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.category_lists, function(list, index) {
                      return _c(
                        "div",
                        { staticStyle: { margin: "bottom: 10px" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "float-left",
                              staticStyle: { width: "40%", color: "#9B9B9B" }
                            },
                            [_vm._v(_vm._s(list.category_name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "float-left",
                              staticStyle: {
                                width: "40%",
                                color: "#9B9B9B",
                                "text-align": "center"
                              }
                            },
                            [_vm._v(_vm._s(list.notification_count))]
                          ),
                          _vm._v(" "),
                          list.notification_count == 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-left",
                                  staticStyle: { width: "20%" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteCategoryConfirm(list.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-times custom-remove",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.category_lists.length == 0
                      ? _c("div", { staticStyle: { "padding-top": "40px" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "float-left",
                              staticStyle: { width: "90%", color: "#9B9B9B" }
                            },
                            [_vm._v("No Notification Categories to display")]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "CreateNotificationModal",
        {
          attrs: { isModalVisible: _vm.isModalVisible },
          on: {
            close: function($event) {
              _vm.isModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Create Notification")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("div", { staticClass: "col-12 override-padding" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.notification_name,
                      expression: "notification_name"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "col-lg-12 input-text form-control",
                  staticStyle: { "line-height": "30px" },
                  attrs: {
                    name: "notification_name",
                    placeholder: "Enter Notification Template Name",
                    maxlength: "140"
                  },
                  domProps: { value: _vm.notification_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.notification_name = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.verrors.firstByRule("notification_name", "required")
                  ? _c(
                      "div",
                      { staticClass: "margin-bottom-5 validate-warning-msg" },
                      [_vm._v("Notification Template Name is required")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c(
                "div",
                {
                  staticClass: "col-9 float-left",
                  staticStyle: { "padding-left": "0" }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "input-text",
                    staticStyle: { "margin-right": "15px" },
                    attrs: {
                      name: "notification_category_id",
                      options: _vm.category_options
                    },
                    model: {
                      value: _vm.notification_category_id,
                      callback: function($$v) {
                        _vm.notification_category_id = $$v
                      },
                      expression: "notification_category_id"
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule(
                    "notification_category_id",
                    "required"
                  )
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Notification Category is required")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-3 override-padding float-left" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-blue col-12",
                    staticStyle: { "line-height": "30px" },
                    on: {
                      click: function($event) {
                        return _vm.createNotification()
                      }
                    }
                  },
                  [_c("b", [_vm._v("Create")])]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "DeleteModal",
        {
          attrs: { isModalVisible: _vm.isDeleteModalVisible, id: _vm.id },
          on: {
            close: function($event) {
              _vm.isDeleteModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Are you sure you want to delete?")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      return _vm.deleteNotification(_vm.id)
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "DeleteCategoryModal",
        {
          attrs: {
            isModalVisible: _vm.isDeleteCategoryModalVisible,
            id: _vm.category_id
          },
          on: {
            close: function($event) {
              _vm.isDeleteCategoryModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Are you sure you want to delete?")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      return _vm.deleteCategory(_vm.category_id)
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-img-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Please wait...\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("hr")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbd9624", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbd9624","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/notification_manager_list.vue
// module id = null
// module chunks = 